


































import Vue from "vue";
import { Computed, Data, Method, Props } from "./formChoicesTypes";
import { mapMutations, mapState } from "vuex";
import { CancelSurveyChoice } from "@/containers/cancelSurveyForm/CancelSurveyChoice";
import { CancelSurveyQuestion } from "@/containers/cancelSurveyForm/CancelSurveyQuestion";

export default Vue.extend<Data, Method, Computed, Props>({
  name: "vc-cancel-survey-form-choices",

  data: function() {
    return {
      selectChoiceId: -1,
      additionalComments: {}
    };
  },
  computed: {
    ...mapState("cancelSurveyForm", ["results"])
  },
  props: {
    question: { default: [] },
    parentQuestionId: { default: -1 }
  },
  methods: {
    ...mapMutations("cancelSurveyForm", ["updateResults"]),

    changeChoice(question: CancelSurveyQuestion, choice: CancelSurveyChoice) {
      if (
        choice.questions.length !== 0 &&
        choice.questions[0].cancelSurveyQuestionType !== "additional_comment"
      ) {
        // 子要素ありの場合かつ子要素が自由記入欄ではない場合、選択なしとする
        this.updateResults({ index: this.parentQuestionId, result: null });
        return;
      }

      const additionalComment = this.additionalComments[choice.choiceId];
      const result = {
        parentQuestionId: this.parentQuestionId,
        questionId: question.questionId,
        choiceId: choice.choiceId,
        additionalComment:
          additionalComment === undefined ? "" : additionalComment
      };
      this.updateResults({ index: this.parentQuestionId, result: result });
    },

    changeAdditionalComment(questionId: number, choice: CancelSurveyChoice) {
      if (choice.choiceId !== this.selectChoiceId) {
        // 今選択している選択肢のコメントではないため、変更を通知しない
        return;
      }

      const additionalComment = this.additionalComments[choice.choiceId];
      const result = {
        parentQuestionId: this.parentQuestionId,
        questionId: questionId,
        choiceId: choice.choiceId,
        additionalComment:
          additionalComment === undefined ? "" : additionalComment
      };
      this.updateResults({ index: this.parentQuestionId, result: result });
    }
  }
});
